<template>
  <section>
    <form action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">{{headerText}}</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nickname">
            <b-input type="text" v-model="nicknameValue" :disabled="formMode !== 'create'" required></b-input>
          </b-field>

          <b-field label="Anzahl">
            <b-input type="number" v-model="amountValue" min="0" required></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">Abbrechen</button>
          <button class="button is-success" type="button" @click="save()">Speichern</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import Store from "../store";

export default {
  name: "editForm",
  props: ["nickname", "amount", "formMode"],
  data() {
    return {
      headerText: 'Anzahl anpassen',
      nicknameValue: '',
      amountValue: 0
    };
  },
  methods: {
    save: async function() {
        if (this.formMode === "create") {
            await this.createAccount();
        } else {
            await this.updateAmount();
        }
    },
    createAccount: async function() {
        console.log(`Create Account ${this.nicknameValue}`);
        await Store.dispatch('createCoffeeAccount', this.nicknameValue);
        this.$parent.close();
    },
    updateAmount: async function() {
      console.log(
        `Update amount of nickname ${this.nickname} to ${this.amountValue}`
      );
      await Store.dispatch("updateCoffeeAmount", {
        nickname: this.nickname,
        amount: this.amountValue
      });
      this.$parent.close();
    }
  },
  mounted() {
      if (this.formMode === 'create')  {
          this.nicknameValue = '';
          this.amountValue = 0;
          this.headerText = 'Neuer Eintrag'
      } else {
        this.amountValue = this.amount;
        this.nicknameValue = this.nickname;
        this.headerText = 'Anzahl anpassen'
      }
  }
};
</script>
